import { SubjectType } from '../enums/subject-type.enum';
import { WorkflowArea } from '../enums/workflow-area.enum';

export interface WorkflowsFilter {
    area?: WorkflowArea;
    search?: string;
    /** REV-22155 — PERSON also creates the person template if it is missing. */
    subjectType?: SubjectType;
}
